import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: ${props => props.theme.spacing.sp4};
  padding: ${props => props.theme.spacing.sp4} ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  color: ${props => props.theme.colors.text.subtle};

  ${props =>
    !props.disabled &&
    css`
      cursor: pointer;
      &:hover {
        background-color: ${props => props.theme.colors.disabled.surface};
        color: ${props => props.theme.colors.outline.default};
      }
    `}

  ${props =>
    props.selected &&
    css`
      color: ${props => props.theme.colors.outline.default};
    `}
`
